<template>
  <div
    class="communityDetail"
    :class="{ 'no-mart': $identity.name !== 'student' }"
  >
    <div class="content">
      <div :class="['left', type == 2 ? '' : 'classesLeft']">
        <div class="avatar" v-if="type == 1">
          <img class="img" :src="info.user ? info.user.avatar : ''" />
          <div class="info">
            <p class="name">
              {{ info.user ? info.user.name : "" }}
              <span
                :class="{
                  'user-type': true,
                  'user-type-admin': info.user_type === 4,
                }"
              >
                {{ info.user_type | enum("UserType") }}
              </span>
            </p>
            <div class>
              <p class="time" v-if="info.created_at">
                {{ info.created_at | tsFormatDate }}
              </p>
            </div>
          </div>
        </div>
        <div :class="['blocks', type == 2 ? 'blocksComunity' : '']">
          <img
            src="@/assets/images/community/isTop.png"
            alt=""
            v-if="info.is_top"
          />
          <img
            src="@/assets/images/community/isFine.png"
            alt=""
            v-if="info.is_fine"
          />
          <span>{{ info.plate ? info.plate.name : "" }}</span>
          <span class="mainTitle" v-if="type == 2">
            {{ info.main ? info.main.title : "" }}
          </span>
        </div>
        <div class="create_time" v-if="type == 2 && info.created_at">
          {{ info.created_at | tsFormatDate }}
        </div>
        <div class="avatar avatarComunity" v-if="type == 2">
          <img class="img" :src="info.user ? info.user.avatar : ''" />
          <div class="info">
            <p class="name">
              {{ info.user ? info.user.name : "" }}
              <span
                :class="{
                  'user-type': true,
                  'user-type-admin': info.user_type === 4,
                }"
              >
                {{ info.user_type | enum("UserType") }}
              </span>
            </p>
          </div>
        </div>
        <div
          class="circle-tag"
          @click="toCircle(info.group_id)"
          v-if="type == 2 && info.group_name"
        >
          <img src="@/assets/images/community/circle-icon.png" alt="" />
          <p>{{ info.group_name }}</p>
        </div>
        <div class="detailContent" v-html="info.content"></div>
        <div class="img_video">
          <div
            class="img_video_item"
            v-for="item in info.resources"
            :key="item.id"
          >
            <img
              :src="item.resource_url"
              alt=""
              v-if="item.type == 1"
              :class="[type == 1 ? 'classesImg' : 'communityImg']"
            />
            <video
              ref="myVideo"
              :src="item.resource_url"
              :controls="controls"
              v-show="item.type == 2"
              :class="[type == 1 ? 'classesImg' : 'communityImg']"
            ></video>
            <img
              src="@/assets/images/community/play.png"
              alt=""
              class="playimg"
              v-if="item.type == 2 && isPlay"
              @click="playVideo"
            />
          </div>
        </div>
        <SetBox
          ref="setBox"
          @handleZan="handleZan"
          @handleCollect="handleCollect"
          @onComplaint="onComplaint"
          @onDelete="onDelete"
          :item="info"
          :isCollect="type == 2"
          hasBack="#fff"
          isDisplay
          isShowDel
        />
        <div class="commentsWrap" v-if="showComment">
          <ReplayInput
            class="replyContent"
            @publishComment="publishComment"
            ref="replayInput"
            :post_id="info.id"
            :index="0"
            :disabled="
              !info.plate ||
              !info.plate.who_can_reply_post.includes(
                $identity.getPlateIdentity(),
              )
            "
          />
          <CommontItem
            v-for="commentItem in comment"
            :key="commentItem.id"
            :item="commentItem"
            :commentId="commentItem.id"
            :index="0"
            :post_id="info.id"
            @publishComment="publishComment"
            @reply="reply"
            :can_reply_comment="can_reply_comment"
            @handleDeleteComment="handleDeleteComment"
          />
          <el-pagination
            background
            layout="total, prev, pager, next"
            @current-change="handle_current_change"
            :page-size="limit"
            :current-page="page"
            :total="totalPage"
            v-if="totalPage > 10"
          ></el-pagination>
        </div>
      </div>
      <div class="right" v-if="type == 2">
        <SectionRight
          :recommend="recommend"
          title="帖子推荐"
          @toOtherDetail="toOtherDetail"
          tip="暂无帖子～"
        />
      </div>
    </div>
    <Complaint ref="complaint"></Complaint>
  </div>
</template>
<script>
import SetBox from "./components/SetBox";
import Complaint from "./components/Complaint";
import CommontItem from "./components/CommentItem";
import ReplayInput from "./components/ReplayInput";
import SectionRight from "./components/SectionRight";
export default {
  name: "CommunityDetail",
  components: { SetBox, Complaint, CommontItem, ReplayInput, SectionRight },
  data() {
    return {
      fromRoute: {
        name: this.$route.query.routeName || "Community",
        label: this.$route.query.routeLabel || "圈子",
        tab: this.$route.query.tab || null,
      },
      id: this.$route.params.id,
      info: {}, //帖子信息
      comment: [], //评论列表
      recommend: [], //推荐列表
      commentId: "", //当前回复的评论ID
      showComment: true, //是否展示评论
      page: 1,
      limit: 10,
      totalPage: 0,
      commentIndex: 0,
      type: 1, //1:班级帖子 2:社区
      can_reply_comment: true,
      controls: false,
      isPlay: true,
    };
  },
  created() {
    this.type = this.$route.params.type;
    this.getPostInfo();
    this.getComment();
    this.getRecommendInfo();
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      this.group_id = this.$route.query.group_id;
      this.getPostInfo();
      this.getComment();
      this.getRecommendInfo();
    },
  },
  methods: {
    // 获取帖子详情
    async getPostInfo(id = "") {
      let data = await this.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/${
          id || this.id
        }`,
        {
          group_id: this.$route.query.group_id,
          id: this.id,
        },
      );
      let count = 0;
      data.content = data.main.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (match, capture) {
          this.imgBox.push(capture);
          count++;
          return (
            match.substring(0, 4) +
            ' index="' +
            count +
            '"' +
            match.substring(4)
          );
        },
      );
      data.content = this.$pub.handleNewLine(data.content);
      this.info = data;
    },
    //打开评论
    handleComment(item) {
      this.showComment = !this.showComment;
      if (
        item.plate.who_can_reply_comment.includes(
          this.$identity.getPlateIdentity(),
        )
      ) {
        this.can_reply_comment = true;
      } else {
        this.can_reply_comment = false;
      }
    },
    //获取评论列表
    async getComment() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
        {
          post_id: that.$route.params.id,
          page: that.page,
          limit: that.limit,
        },
      );
      let arr = data.data;
      for (let i = 0; i < arr.length; i++) {
        arr[i].replyShow = false;
        arr[i].content = arr[i].content.replace(/\n/g, "<br/>");
        arr[i].showCommentInput = false;
      }
      that.comment = arr;
      that.totalPage = data.total;
    },
    //发布评论
    async publishComment(obj) {
      console.log(obj);
      await this.$http.post(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment`,
        {
          post_id: this.info.id,
          content: obj.comment,
          reply_id: this.commentId,
        },
      );
      this.getComment();
      this.$refs.replayInput.comment = "";
    },
    //获取回复的评论id
    reply(obj) {
      console.log("点击回复评论");
      console.log(obj);
      this.commentId = obj.id;
      this.commentIndex = obj.index;
    },
    //删除评论
    async handleDeleteComment(obj) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
        customClass: "confirm-common",
      });
      await this.$http.delete(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/comment/` +
          obj.id,
      );
      this.getComment();
    },
    //点赞
    async handleZan(post_id) {
      await this.$http.post(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/like`,
        { post_id },
      );
      this.getPostInfo();
    },
    //收藏
    async handleCollect(post_id, is_collected) {
      if (is_collected) {
        await this.$http.put(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect/` +
            is_collected,
          {
            post_id,
          },
        );
      } else {
        await this.$http.post(
          `/api/${this.$identity.getCommunityClientApiLetter()}/community/collect`,
          {
            post_id,
          },
        );
      }
      this.getPostInfo();
    },
    //举报
    onComplaint(id) {
      this.$refs.complaint.show(5, id);
      this.$refs.setBox.ishowBtn = false;
    },
    //删除
    async onDelete(id) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
        customClass: "confirm-common",
      });
      await this.$http.delete(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/` +
          id,
      );
      this.$router.go(-1);
    },
    //获取推荐帖子列表
    async getRecommendInfo() {
      const that = this;
      let data = await that.$http.get(
        `/api/${this.$identity.getCommunityClientApiLetter()}/community/post/recommend`,
        {
          group_id: that.$route.params.group_id, //圈子
          limit: 5,
          except: that.$route.params.id,
        },
      );
      that.recommend = data;
    },
    //前往圈子
    toCircle(id) {
      this.$router.push({
        name: "CommunityGroupShow",
        params: { id },
      });
    },
    //跳转其他帖子
    toOtherDetail(item) {
      this.$router.push({
        name: "CommunityDetail",
        params: {
          id: item.id,
          group_id: item.group_id,
          type: 2,
        },
      });
      this.$refs.setBox.ishowBtn = false;
    },
    // 分页加载数据
    handle_current_change(val) {
      this.page = val;
      this.getComment();
    },
    //播放视频
    playVideo() {
      //列表循环video 需要指定唯一ref
      this.$refs["myVideo"][0].play();
      this.controls = true;
      this.isPlay = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.communityDetail {
  width: 100%;
  margin: 16px auto;
  &.no-mart {
    margin-top: 0;
  }
  .bread {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    box-sizing: border-box;
  }
  .content {
    overflow: hidden;
    .left {
      width: 896px;
      background-color: #fff;
      padding: 24px 32px;
      box-sizing: border-box;
      float: left;
      .avatar {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        .img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 10px;
          border: 1px solid #e6e6e6;
          box-sizing: border-box;
        }
        .info {
          display: inline-block;
          max-width: 100%;
          border-radius: 30px;
          box-sizing: border-box;
          .name {
            height: 21px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(32, 36, 42, 1);
            line-height: 21px;
            .user-type {
              color: $primary-color;
              border: 1px solid $primary-color;
              font-size: 12px;
              padding: 0 2px;
              border-radius: 3px;
            }
            .user-type-admin {
              background-color: #666564;
              color: #ead2ab;
              border: 0;
            }
          }
          div {
            display: flex;
            margin-top: 10px;
            p {
              margin-right: 15px;
              font-size: 14px;
              color: #999;
              line-height: 12px;
              span {
                display: inline-block;
                margin: 0 5px;
                color: $primary-color;
                cursor: pointer;
              }
            }
          }
        }
      }
      .avatarComunity {
        margin: 24px 0;
      }
      .blocks {
        margin: 32px 0 24px 0;
        img {
          width: 30px;
          height: 18px;
          vertical-align: -2px;
        }
        img:nth-child(2) {
          width: 18px;
          margin: 0 8px 0 6px;
        }
        span {
          font-size: 20px;
          font-weight: 600;
          color: #333;
        }
        .mainTitle {
          position: relative;
          padding-left: 20px;
          &::after {
            content: "";
            position: absolute;
            left: 10px;
            top: 5px;
            width: 1px;
            height: 18px;
            opacity: 1;
            background: #666666;
          }
        }
      }
      .blocksComunity {
        margin: 0;
      }
      .create_time {
        color: #999999;
        margin-top: 10px;
      }
    }
    .classesLeft {
      width: 100%;
    }
    .circle-tag {
      align-items: center;
      font-size: 13px;
      color: #f09208;
      background: #fff6e9;
      border-radius: 24px;
      padding: 5px 10px;
      display: inline-flex;
      margin-bottom: 18px;
      cursor: pointer;
      img {
        width: 12px;
        height: 11px;
        margin-right: 6px;
      }
    }
    .img_video {
      .img_video_item {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        img,
        video {
          margin-top: 40px;
        }
        .communityImg {
          max-width: 656px;
        }
        .classesImg {
          max-width: 880px;
        }
        .playimg {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 48px;
          height: 48px;
          cursor: pointer;
          padding: 20px;
          margin-top: -24px;
          margin-left: -44px;
        }
      }
    }
    .right {
      float: right;
      width: 288px;
      margin-left: 16px;
      height: auto;
      background-color: #fff;
    }
    .commentsWrap {
      background: #f7f7f7;
      padding: 12px 24px 1px 24px;
      .replyContent {
        border-bottom: 1px solid #e6e6e6;
        padding-top: 8px;
        padding-bottom: 20px;
      }
    }
  }
}
</style>
